import { NBSP, PERCENT, RUB } from 'shared/constants/common';
import { IRate, TMapOffersResult } from 'shared/types/common/offer';
import { formatNumberWithSpaces, transformNumToString } from 'shared/utils/common';
import { flattenOffersList } from 'shared/utils/offers/flattenOffersList';
import { getBankLogoUrl } from 'shared/utils/offers/mapCalculatorOfferModalToTermsModal';

export interface IOffersSummary {
  paymentText: string | null;
  rateText: string | null;
  bankLogos: string[];
}

const getEffectiveRate = (rate?: IRate | null): number | null => {
  if (!rate) {
    return null;
  }

  return rate.discount && rate.rateWithDiscount != null ? rate.rateWithDiscount : rate.rate;
};

export const getOffersSummary = (offersList: TMapOffersResult): IOffersSummary | null => {
  const flatOffers = flattenOffersList(offersList);

  if (flatOffers.length === 0) {
    return null;
  }

  let minPayment: number | null = null;
  let minRate: number | null = null;
  const bankLogos: string[] = [];
  const seenLogos = new Set<string>();

  for (const offer of flatOffers) {
    const { monthlyPayment, rate } = offer.conditions;
    const { iconPath } = offer.title;

    if (monthlyPayment != null && (minPayment == null || monthlyPayment < minPayment)) {
      minPayment = monthlyPayment;
    }

    const effectiveRate = getEffectiveRate(rate);

    if (effectiveRate != null && (minRate == null || effectiveRate < minRate)) {
      minRate = effectiveRate;
    }

    if (iconPath && !seenLogos.has(iconPath)) {
      seenLogos.add(iconPath);
      bankLogos.push(getBankLogoUrl(iconPath));
    }
  }

  return {
    paymentText: minPayment != null ? `От${NBSP}${formatNumberWithSpaces(minPayment)}${NBSP}${RUB}/мес` : null,
    rateText: minRate != null ? `Ставка от${NBSP}${transformNumToString(minRate)}${PERCENT}` : null,
    bankLogos,
  };
};
